module.exports = __webpack_public_path__ + "img/supervision-2.beb508cf.png";